import React from "react";
import { VideoCameraIcon } from "@heroicons/react/solid";
import { MailIcon } from "@heroicons/react/solid";
import { BriefcaseIcon } from "@heroicons/react/solid";
import { CalendarIcon } from "@heroicons/react/solid";

import { mail } from "../data";

//const sendmail = require("sendmail")({ smtpHost: "localhost", smtpPort: 25 });

export default function Contact() {
  const [name, setName] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [message, setMessage] = React.useState("");

  function encode(data) {
    return Object.keys(data)
      .map(
        (key) => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]),
      )
      .join("&");
  }

  function handleSubmit(e) {
    e.preventDefault();

    fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: encode({ "form-name": "test", name, email, message }),
    })
      .then(() => alert("Message sent!"))
      .catch((error) => alert(error));
  }

  return (
    <section id="contact" className="relative">
      <div className="container px-5 py-10 mx-auto flex sm:flex-nowrap flex-wrap">
        <div className="lg:w-2/3 md:w-1/2 bg-gray-900 rounded-lg overflow-hidden sm:mr-10 p-10 flex items-end justify-start relative">
          <div className="bg-gray-900 relative flex flex-wrap py-6 rounded shadow-md">
            <div className="lg:w-1/2 px-6">
              <h2 className="title-font font-semibold text-white tracking-widest text-xs">
                ADDRESS
              </h2>
              <p className="mt-1">Milnerton Cape Town, 7441</p>
            </div>
            <div className="lg:w-1/2 px-6 mt-4 lg:mt-0">
              <h2 className="title-font font-semibold text-white tracking-widest text-xs">
                EMAIL
              </h2>
              <a className="text-indigo-400 leading-relaxed">
                dave@da-email.slmail.me
              </a>
              <h2 className="title-font font-semibold text-white tracking-widest text-xs mt-4">
                PHONE
              </h2>
              <p className="leading-relaxed">RSA: +27 83 234 7005</p>
              <p className="leading-relaxed">IL: +972 52 438 8843</p>
            </div>
          </div>
        </div>
        <div></div>
        <form
          netlify
          name="test"
          onSubmit={handleSubmit}
          className="lg:w-1/3 md:w-1/2 flex flex-col md:ml-auto w-full md:py-8 mt-8 md:mt-0"
        >
          <h2 className="text-white sm:text-4xl text-3xl mb-1 font-medium title-font">
            Hire Me
          </h2>
          <p className="leading-relaxed mb-5">
            Let's get building and turn your app idea into reality! Contact me
            today.
          </p>
          <div className="relative mb-2">
            <h4 className="text-white sm:text-xl text-3xl mb-1 font-medium title-font">
              <a
                href="https://calendar.proton.me/bookings#QbuMI_0JVc-5HuOzLGWpc8pn13of4RAMxeBlMhC0q_I="
                target="_blank"
                key="001"
                className="sm:w-1/2 w-100 "
              >
                {}Online Appointment
              </a>
            </h4>
            <p>
              {" "}
              <a
                href="https://calendar.proton.me/bookings#QbuMI_0JVc-5HuOzLGWpc8pn13of4RAMxeBlMhC0q_I="
                target="_blank"
                key="001"
                className="sm:w-1/2 w-100 "
              >
                Book a Time Slot{" "}
                <CalendarIcon className="mx-auto inline-block w-10 ml-2" />
              </a>
            </p>
          </div>
          <div className="relative mb-4">
            <h3 className="text-white sm:text-xl text-3xl mb-1 font-medium title-font">
              Send a Email
            </h3>
            <label htmlFor="name" className="leading-7 text-sm text-gray-400">
              Name
            </label>
            <input
              type="text"
              id="name"
              name="name"
              className="w-full bg-gray-800 rounded border border-gray-700 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-900 text-base outline-none text-gray-100 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
              onChange={(e) => setName(e.target.value)}
            />
          </div>
          <div className="relative mb-4">
            <label htmlFor="email" className="leading-7 text-sm text-gray-400">
              Email
            </label>
            <input
              type="email"
              id="email"
              name="email"
              className="w-full bg-gray-800 rounded border border-gray-700 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-900 text-base outline-none text-gray-100 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="relative mb-4">
            <label
              htmlFor="message"
              className="leading-7 text-sm text-gray-400"
            >
              Message
            </label>
            <textarea
              id="message"
              name="message"
              className="w-full bg-gray-800 rounded border border-gray-700 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-900 h-32 text-base outline-none text-gray-100 py-1 px-3 resize-none leading-6 transition-colors duration-200 ease-in-out"
              onChange={(e) => setMessage(e.target.value)}
            />
          </div>
          <button
            type="submit"
            className="text-white bg-indigo-500 border-0 py-2 px-6 focus:outline-none hover:bg-indigo-600 rounded text-lg"
          >
            Submit
          </button>
        </form>
      </div>
    </section>
  );
}



// WEBPACK FOOTER //
// ./src/components/Contact.js